export default __webpack_public_path__ + "static/media/avanto_icon.44e21879.svg";